"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProgramTable = require("./ProgramTable");
Object.keys(_ProgramTable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProgramTable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProgramTable[key];
    }
  });
});